// extracted by mini-css-extract-plugin
export default {"container":"nyGkGBYdZH9DeC_vOeg9","content":"sc22LgRZgiQdgbISpUIK","image":"_oiNA5Xax62QUuvZnJX3","left":"lgv3kafIt4WKEXYCjvxA","right":"upruJ24rEvB6aAdMAjNQ"};